import { useCallback, useEffect, useState } from "react";
import { API_EQUIPMENT, BASE_INFO } from "../constants/api";
import { EquipmentInfoResponseType } from "../types/connected-object";
import useRequest from "./useRequest";
import { RequestError } from "../errors/RequestError";

const useEquipmentInfo = () => {
  const [isNotFound, setIsNotFound] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const {
    error: reqError,
    isLoading,
    response,
    request
  } = useRequest<EquipmentInfoResponseType>();

  useEffect(() => {
    if (reqError instanceof RequestError) {
      if (reqError.status === 404) {
        setIsNotFound(true);
        setError(null);
      } else {
        setError(reqError);
        setIsNotFound(false);
      }
    } else {
      setError(reqError);
      setIsNotFound(false);
    }
  }, [reqError]);

  const getEquipmentInfo = useCallback((objCode: string) => {
    setIsNotFound(false);
    request(BASE_INFO, `${API_EQUIPMENT}/${objCode}`);
  }, [request]);

  return {
    isLoading: isLoading ?? false,
    equipmentInfo: response,
    isNotFound,
    error,
    getEquipmentInfo
  };
};

export default useEquipmentInfo;
